import * as ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'

import App from './app/app'

const shouldInitializeSentry = () => {
  const hostname = window.location.hostname;
  const env = process.env.NODE_ENV;
  const isProduction = env === 'production';
  const isNotTestOrLocalhost = !hostname.includes('test') && !hostname.includes('localhost');
  return isProduction && isNotTestOrLocalhost;
}

if (shouldInitializeSentry) {
  // dsn: "https://fcd7e9549dbd36bf24dfcb1621a0fc3c@o426068.ingest.us.sentry.io/4507453209903104",
  Sentry.init({
    dsn: "https://ff598f752f9a3017f053ffb171f1b3e3@o4509758004527104.ingest.de.sentry.io/4509758030151760",
    environment: process.env.NODE_ENV,
    ignoreErrors: ["AxiosError", "[mobx-state-tree]"],
  })
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)